import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, FieldLabel, FieldSelect, FlexBox, Modal, ModalBody, ModalFoot, ModalHead, Text, } from '@dixa/lib-shared-habla';
import { produce } from 'immer';
import noop from 'lodash/noop';
import { useCallback, useState } from 'react';
import { analytics } from 'app/utils/segment';
import { DateCard } from 'components/settings/components/sections/openingHours/components/dateCard/dateCard';
import styles from './recoverHolidaysModal.module.scss';
export const RecoverHolidaysModal = ({ country, holidays, onClose, onSubmit, }) => {
    const { name, country_code: id } = country;
    const [selectedHolidays, setSelectedHolidays] = useState({});
    const handleDateClick = useCallback((holiday) => () => void setSelectedHolidays(produce((selectedHolidays) => {
        if (selectedHolidays[holiday.id]) {
            delete selectedHolidays[holiday.id];
        }
        else {
            selectedHolidays[holiday.id] = holiday;
        }
    })), []);
    const handleSubmit = useCallback(() => {
        analytics.businessHoursScheduleRecoverHolidaysFormSubmitted();
        onSubmit(selectedHolidays);
        onClose();
    }, [selectedHolidays, onClose, onSubmit]);
    const handleCancelModal = useCallback(() => {
        analytics.businessHoursScheduleRecoverHolidaysFormCancelled();
        onClose();
    }, [onClose]);
    return (_jsx(Modal, Object.assign({ isOpen: true, onClose: handleCancelModal }, { children: _jsxs(Box, Object.assign({ width: "600px" }, { children: [_jsx(ModalHead, Object.assign({ onClose: handleCancelModal, title: "Recover deleted holidays" }, { children: _jsx(Text.Paragraph, Object.assign({ subdued: true, variant: "2" }, { children: "This allows you to recover holidays from the holiday calendar you deleted previously (but not your own exceptions). Recovered holidays are set as \u201Cclosed\u201D." })) })), _jsxs(ModalBody, { children: [_jsx(FieldSelect, { disabled: true, input: {
                                name: 'holiday-calendar',
                                value: id,
                                onChange: noop,
                            }, items: [{ id, name }], label: "Holiday calendar" }), _jsxs(FlexBox, Object.assign({ flexDirection: "column", gap: "200", margin: "300 0 0" }, { children: [_jsx(FieldLabel, { children: "Deleted holidays" }), _jsx("div", Object.assign({ className: styles.dateWrapper }, { children: holidays.map((holiday) => (_jsx(DateCard, { exception: holiday, isSelected: !!selectedHolidays[holiday.id], onClick: handleDateClick(holiday) }, holiday.id))) }))] }))] }), _jsx(ModalFoot, { cancelOnClick: handleCancelModal, confirmProps: { disabled: !Object.keys(selectedHolidays).length }, confirmName: "Recover selected holidays", confirmOnClick: handleSubmit })] })) })));
};
